import { combineReducers } from 'redux';
import userReducer from './userReducer';
import menuReducer from './menuReducer';
import healthCheckReducer from './healthCheckReducer';
import b2bPermissionsReducer from './b2bPermissionsReducer';

export default combineReducers({
    userReducer,
    menuReducer,
    healthCheckReducer,
    b2bPermissionsReducer,
});
